import type { SelectOption } from 'components/types';

type DropdownItemList = {
  heading: string;
  items: SelectOption<string, string>[];
}[];

type UseDropdownUtilities = {
  createListItems: (items: DropdownItemList) => SelectOption<string, string>[];
};

export const useDropdownUtilities = (): UseDropdownUtilities => {
  const createListItems = (items: DropdownItemList) => {
    const list = items.flatMap((item) => {
      const heading: SelectOption<string, string> = {
        value: item.heading,
        display: item.heading,
        isDisabled: true,
      };

      const listItems: SelectOption<string, string>[] = item.items.map(
        (item) => {
          return {
            value: item.value,
            display: item.display,
            isDisabled: false,
          };
        },
      );

      return [heading, ...listItems];
    });
    return list;
  };
  return { createListItems };
};
